<template>
  <v-dialog v-model="showDialog" persistent max-width="600" :fullscreen="false">
    <v-card>
      <v-card-title class="headline info lighten-1 white--text d-flex align-center">
        <v-icon left color="white" class="mr-2">mdi-information-outline</v-icon>
       {{ this.t('common','STR_UPDATE_AVAIL') }}
      </v-card-title>

      <v-card-text class="py-4">
    <p v-html="this.t('common','STR_ERR_UPDATEAPP')">
       
        </p> 
       
      </v-card-text>

      <v-card-actions class="justify-center pb-4 pt-0">
        <v-btn color="info" @click="forceReload" large class="px-8">
          <v-icon left>mdi-update</v-icon>  {{ this.t('common','STR_UPDATE_BUTTON') }}
        </v-btn>
      </v-card-actions>

      <!-- <v-card-actions class="justify-center pb-4 caption text--disabled">
          Die Seite wird neu geladen.       </v-card-actions>-->
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'aedUpdateDialog',

  props: {
    isUpdateAvailable: {
      type: Boolean,
      required: true,
    }
  },

  computed: {
    showDialog: {
      get() {
        return this.isUpdateAvailable;
      },
      set() {
        // Persistenter Dialog, kann nicht geschlossen werden
      }
    }
  },

  methods: {
   forceReload() {
        console.log('Führe forceReload durch...');
        
        // 1. Storage bereinigen
        localStorage.clear(); 
        console.log('Local Storage geleert.');

        // 2. Zur Home-Route navigieren, bevor neu geladen wird.
       
        if (this.$router) {
            // Führt einen Hard-Redirect auf die Basis-URL aus, um 
            this.$router.push('/').catch(err => {
                // Fehler abfangen, falls wir bereits auf '/' sind oder 
                // Navigation fehlschlägt. Der reload kommt danach.
                if (err.name !== 'NavigationDuplicated') {
                    console.error('Fehler bei der Navigation zur Home-Route:', err);
                }
            });
        }

        // 3. Erzwingt den Neuladevorgang vom Server
        setTimeout(() => {
            window.location.reload(true);
        }, 100); 
    }
  }
}
</script>

<style scoped>
/* Unveränderte Styles */
.headline {
  font-size: 1.5rem !important;
  display: flex;
  align-items: center;
}
</style>